import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";

import image1 from '../Images/mehta.png';
import image2 from '../Images/sophia.png';
import daniel from '../Images/daniel.png';
import image4 from '../Images/priya.png';
import image5 from '../Images/liam.png';
import maya from '../Images/maya.png';
import patel from '../Images/patel.png';

const testimonialsData = [
  { quote: "The process was smoother than I ever imagined. They took care of everything while I relaxed.", name: "Aarav Mehta", role: "Entrepreneur", rating: 5, avatar: image1 },
  { quote: "I didn’t just file my taxes—I learned how to save smarter. Truly impressed with their insights!", name: "Sophia Williams", role: "Freelance Developer", rating: 5, avatar: image2 },
  { quote: "Professional, reliable, and incredibly efficient. I never felt this confident during tax season.", name: "Daniel Thompson", role: "Consultant", rating: 4, avatar: daniel },
  { quote: "Their personalized guidance gave me peace of mind. I knew I was in good hands.", name: "Priya Sharma", role: "Software Engineer", rating: 5, avatar: image4 },
  { quote: "Friendly, approachable, and always ready to help. Filing taxes no longer feels stressful.", name: "Liam Anderson", role: "Photographer", rating: 5, avatar: image5 },
  { quote: "I saved more than I expected thanks to their expert planning. Highly recommended!", name: "Maya Fernandez", role: "Startup Founder", rating: 5, avatar: maya },
  { quote: "They turned a complicated process into a seamless experience. True professionals.", name: "Ethan Patel", role: "Small Business Owner", rating: 5, avatar: patel },
];

const Testimonials = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;

    const autoScroll = () => {
      if (scrollContainer && !isPaused) {
        scrollContainer.scrollLeft += 1; // 👈 directly increment scrollLeft
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0; // reset smoothly
        }
      }
    };

    const interval = setInterval(autoScroll, 20); // smaller step, smoother scroll
    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <div className="testimonials-container">
      <h1 className="testimonials-title">What Our Clients Say</h1>
      <div className="testimonials-carousel">
        <div className="testimonials-wrapper" ref={scrollRef}>
          {/* Double data for infinite loop */}
          {[...testimonialsData, ...testimonialsData].map((testimonial, index) => (
            <div
              key={index}
              className="testimonial-card"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <blockquote>
                <span className="quote-icon">“</span>
                <p>{testimonial.quote}</p>
              </blockquote>
              <div className="testimonial-user">
                <img src={testimonial.avatar} alt={testimonial.name} />
                <div>
                  <h3>{testimonial.name}</h3>
                  <p>{testimonial.role}</p>
                  <div className="rating">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <span key={i}>&#9733;</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
